import React, {useState} from 'react'
import {Card, Row, Space, Table} from "antd";
import {warehouseStockReports} from "../../services/serviceReports";
import {SearchOutlined} from "@ant-design/icons";
import Filter from "../filterWrapper/Filter";
import WarehouseStockReportsFilter from "./WarehouseStockReportsFilter";


const setTableRowKeys = (r, index) => index

const WarehouseStockReports = () => {
    const [tableData, setTableData] = useState()
    const [openFilter, setOpenFilter] = useState(false)


    const clearTable = () => setTableData([])

    const toggleFilterDisplay = () => setOpenFilter(!openFilter)
    const columns = [
        {title: 'Stok Kodu', dataIndex: 's'},
        {title: 'Stok Adı', dataIndex: 'n'},
        {title: 'Stok Açıklaması', dataIndex: 'd'},
        {title: 'Depo', dataIndex: 'w', render: (t) => t.toLocaleUpperCase()},
        {title: 'Adet', dataIndex: 'q', render: (t) => t.toFixed(2)},
        {title: 'Toplam', dataIndex: 't', render: (t) => t.toFixed(2)},
        {title: 'Kur', dataIndex: 'c'}
    ]

    const handleFilter = (...filterData) => {
        warehouseStockReports(filterData[0])
            .then(({data}) => setTableData(data))

        return new Promise((resolve, reject) => {
            resolve(true)
            reject(false)
        })
    }

    return(
        <React.Fragment>
            <Card
                title={'Stok Raporları'}
            >
                <Space direction={"vertical"} size={'large'} style={{width: '100%'}}>
                    <Row justify={"start"}>
                        <div className={'filter-row-container'} onClick={toggleFilterDisplay}><SearchOutlined/></div>
                    </Row>
                    <Table rowKey={setTableRowKeys} columns={columns} dataSource={tableData}/>
                </Space>
            </Card>

            {
                <Filter
                    showDrawer={openFilter}
                    closer={toggleFilterDisplay}
                    relatedComponent={'Stok Raporlama'}
                    handler={handleFilter}
                    resetHandler={clearTable}
                >
                    <WarehouseStockReportsFilter />
                </Filter>
            }

        </React.Fragment>
    )
}
export default WarehouseStockReports